/* eslint-disable max-len */
import 'react';

const DocRecommendFoldSvg = () => (
    <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M3.431 7.772V2.228a.5.5 0 01.818-.386l3.367 2.772a.5.5 0 010 .772L4.25 8.158a.5.5 0 01-.818-.386z" fill="#5C6473" opacity=".6" /></svg>
);

export default DocRecommendFoldSvg;
